import React from "react"
import { Container } from "react-bootstrap"

import LanguageSelector from "../languageSelector/LanguageSelector"
import SiteSocialLinks from "../siteSocialLinks/SiteSocialLinks"
import * as styles from "./MetaNav.module.scss"

const MetaNav = ({ settings, lang }) => {
  return (
    <div>
      <Container>
        <div className={styles.metaNavWrapper}>
          <div style={{float: "right"}}>
            <div className={styles.item}><LanguageSelector language_selector={settings ? settings.language_selector : {}} lang={lang} /></div>
            <div className={styles.item}><SiteSocialLinks settings={settings} /></div>
          </div>
          <div style={{clear: "both"}} />
        </div>
      </Container>
    </div>
  )
}

export default MetaNav
